import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import MenuItem from '../components/MenuItem';
import '../App.css';

import Auth from '../core/services/auth';
import { NavLink } from 'react-router-dom';
import Avatar from 'react-avatar';
// import { posts } from '../core/lib/data';
// import clsx from 'clsx';
import { DataResponsetype, Vendor } from '../core/lib/types';
import ProfilePostComponent from '../components/ProfilePostComponent';
import InfiniteScroll from 'react-infinite-scroll-component';

function Profile () {

    const [ open, setOpen ] = useState(false)
    const [ openVendor, setOpenVendor] = useState(false)
    const [ type, setType ] = useState("")
    const [ params, setParams ] = useState({
        page: 1, limit: 6, sort: "-createdAt", userId: Auth.getUser()._id
    })
    const [ post, setPost ] = useState<DataResponsetype>({ total: 0, pages: 0, page: 0, limit: 0, data: [] })
   
    const getData = useCallback(() =>{
        //
        // setType(args)

        if (type === "posts") {
            //
            Auth.api.get("/posts", { params: params} ).then(res=>{
                setPost(res.data.data)
            })

        } else if (type === "pins") {
            //
            Auth.api.get("/pins", { params: { page: params.page, limit: params.limit, sort: params.sort }}).then(res=>{

                // //
                // const { limit, page, pages, total, data } = res.data.data
                // const pins = data.map(
                //     ( pins: { post: any; }) => pins.post
                // )

                setPost(res.data.data)
            })
            
        } else {
            Auth.api.get("/posts", { params: params} ).then(res=>{
                setPost(res.data.data)
            })
        }

    }, [ params, type])

    //
    useEffect(()=>{
        // 
        if (type === 'posts') {
            setType('')
        }
        
        getData()
    }, [ setType,getData,type ])
    
    // let getUser = () => {
    const user = Auth.getUser()
    const vendors = Auth.getVendor()

    const vendorList = vendors.map(
        // _story => <StoryComponent story={_story} />
        // _story => <li> {_story.caption} </li>
        (vendor: Vendor) => 
            <NavLink key={vendor.name} className="flex flex-row items-center space-y-1 relative" to="/vendor" state={{name: vendor.name}}>
                <button type="button" className="relative inline-flex items-center w-full px-4 py-2 font-medium  rounded-t-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400 dark:bg-black dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                    {('logo' in vendor) ?
                                    
                        <div style={{width:'25px', height: '25px'}} className="mr-2 bg-gray-100 border-slate-400 rounded-full">
                            <div className="bg-white block rounded-full ">
                            <img alt='profile' className='rounded-full object-cover aspect-square' src={vendor.logo.url}/>
                            </div>
                        </div>
                                    
                    :
                    <Avatar round={true} size='25' className='mr-2' name={user.username} />
                    }
                    <p className='font-medium text-xs'>{vendor.name}</p>
                    
                </button>
            </NavLink>
    )
    
    const _posts = post.data.length > 0 ? post.data : []

    const postItems = _posts.map(
        (post: any, index) => 
          <ProfilePostComponent 
            key={index}
            caption={post.caption} 
            media={post.media} 
            user={post.user} 
            location={post.location} 
            id={post.id} 
            vendor={post.vendor}
            createdAt={post.createdAt}
            meta={post.meta}
            user_action={post.user_action}
            posts={_posts}
            profile={post.profile}
            likedBy={post.likedBy}
            likes={post.likes}
            pinnedBy={post.pinnedBy ? post.pinnedBy : []}
            total={post.total}
            />
          
      )
      
      const onSet = (ars: string) => {
        //
        setParams({
            page: 1, limit: 6, sort: "-createdAt", userId: Auth.getUser()._id 
        })
        setType(ars)
      }

      const fetchData = () => {
        //
        if (post.data.length >= post.total) {
            // setMore(false)
            return;
        }

          params.page++

        //   console.log(params)
  
          Auth.api.get(type === 'posts' ? "/posts" : '/pins', type === 'posts' ? { params: params} : { params: { page: params.page, limit: params.limit, sort: params.sort } }).then(res=>{
            //
  
            setPost(res.data.data)
  
            // const data = { total: res.data.data.total, pages: res.data.data.pages, page: _page, limit: _limit, data: [...post.data, ...res.data.data.data] }
  
            setPost({
              total: post.total, 
              pages: post.pages, 
              page: post.page, 
              limit: post.limit,
              data: post.data.concat(res.data.data.data)
            })
  
            // console.log(post.data)
            
            // console.log(params)
          })
      }

    return (
        <section className='dark:bg-gray-800 dark:text-white'>
          
          <div className="flex flex-col px-6 py-8 mx-auto md:h-screen ">

                <div className='flex w-full flex-col justify-left p-2'>
                    <div className="flex flex-row items-center space-y-1 relative">
                                
                                <NavLink className="flex flex-row items-center space-y-1 relative" to="/account">
                                {(user.profile.profileImage) ?
                                    
                                    <div style={{width:'65px', height: '65px'}} className="border bg-gray-100 border-slate-400 rounded-full">
                                        <div className="bg-white block rounded-full  hover:-rotate-6 transform transition">
                                        <img alt='profile' className='rounded-full object-cover aspect-square p-0.5' src={user.profile.profileImage.url}/>
                                        </div>
                                    </div>
                                    
                                :
                                    !(user.profile.profileImage) &&
                                        <Avatar round={true} size='65' name={ user.profile.firstName ? user.profile.firstName+' '+(!user.profile.lastName ? '' : user.profile.lastName) : 'Firstname Lastname'} />
                                    }
                                    <div className='ml-4 text-left  '>
                                        <h2 className='text-md font-bold mb-0 pb-0'>{ user.profile.firstName ? user.profile.firstName+' '+(!user.profile.lastName ? '' : user.profile.lastName) : 'Firstname Lastname' }</h2>
                                        <p className='text-sm text-gray-500 mb-0 pb-0'>@{ user.username.split('-').length > 2 ? user.username.split('-')[0] : user.username }</p>
                                    </div>
                                </NavLink>
                                <button onClick={e=>setOpen(true)} className="p-4 ">
                                {/* className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full"
                                fill='currentColor' className="w-5 h-5" */}
                                    <svg className="w-5 h-5 dark:fill-white" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="KeyboardArrowDownOutlinedIcon"><path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"></path></svg>
                                </button>
                                
                    </div>
                    
                    <div className='flex flex-row py-5'>
                        <button onClick={e=> onSet('pins')} type="button" className="py-1.5 px-5 me-2 mb-2 text-xs font-medium focus:outline-none rounded-full border border-gray-200 hover:bg-gray-100 focus:bg-gray-700 focus:text-white
                        ">Pins</button>

                        <button onClick={e=> onSet('posts')} type="button" className="text-dark hover:bg-gray-900 focus:outline-none  focus:text-white hover:text-white font-medium rounded-full text-xs px-5 py-1.5 me-2 mb-2 border border-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700 click:bg-gray-900 click:text-white">Posts</button>
                    </div>
                </div>

                <div className="md:h-screen mx-auto space-y-2 mb-20">
                    <InfiniteScroll
                        dataLength={post.data.length}
                        hasMore={true}
                        next={fetchData}
                        loader={<p className='text-center'></p>}
                    >
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-1">
                        
                            {
                                // _posts.map(
                                //     (post: any, index) => 
                                //       <ProfilePostComponent 
                                //         key={index}
                                //         caption={post.caption} 
                                //         media={post.media} 
                                //         user={post.user} 
                                //         location={post.location} 
                                //         id={post.id} 
                                //         vendor={post.vendor}
                                //         createdAt={post.createdAt}
                                //         meta={post.meta}
                                //         user_action={post.user_action}
                                //         profile={post.profile}
                                //         />
                                    
                                //   )
                                postItems
                            }
                        </div>
                    </InfiniteScroll>
                </div>

                <Dialog open={open} onClose={setOpen} className="relative z-40">
                    <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                    />

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                        <DialogPanel
                        transition
                        className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 "
                        >

                            <div className="w- text-gray-900 bg-white rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white p-6">
                                <NavLink className="flex flex-row items-center space-y-1 relative" to="/account">
                                    <button type="button" className="relative inline-flex items-center w-full px-4 py-2 font-medium  rounded-t-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400 dark:bg-black dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                                        <Avatar round={true} size='25' className='mr-2' name={user.profile.firstName+' '+user.profile.lastName} />
                                        <p className='font-medium text-xs'>{user.profile.firstName+' '+user.profile.lastName}</p>
                                        
                                    </button>
                                </NavLink>
                                { vendorList }
                                <button onClick={e=>setOpenVendor(true)} type="button" className="relative inline-flex items-center w-full px-4 py-3 font-medium rounded-b-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400 dark:bg-black dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">

                                    <svg className="w-6 h-6 me-2.5  dark:fill-white" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="AddCircleOutlineOutlinedIcon"><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"></path></svg>
                                        <p className='font-medium text-xs'>Add Vendor Account</p>
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                    </div>
                </Dialog>

                <Dialog open={openVendor} onClose={setOpenVendor} className="relative z-40">
                    <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                    />

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                        <DialogPanel
                        transition
                        className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                        >
                            <div className="space-y-4 p-6 w-full pb-8">
                                <div className='pt-2 px-2  text-left'>
                                    <p className='text-sm font-medium'> Vendor Account</p>
                                </div>
                                <div className='flex flex-col space-y-4 '>
                                    <NavLink to="/vendor-login">
                                        <button className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Login with Existing Account</button>
                                    
                                    </NavLink>
                                    <NavLink to="/create-vendor">

                                        <button className="w-full rounded-full text-dark bg-white hover:bg-gray-50 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-4 text-center dark:border-black dark:bg-black dark:hover:bg-gray-800 dark:focus:ring-primary-800 dark:hover:border-slate-500">Create New Account</button>
                                    
                                    </NavLink>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                    </div>
                </Dialog>
            <MenuItem />
          </div>
        </section>
    );
  }
  
  export default Profile;
  

